import React, { Component } from 'react';

const cmeBrandedIcons = [
  'multi-fill',
  'cube',
  'pause-circle',
  'remove-circle',
  'logout',
  'login',
  'cancellation-history',
  'close-circle-o',
  'profile',
  'search',
  'maximize-circle-o',
  'remove-circle-o',
  'settings',
  'fill',
  'chat',
  'person-add',
  'line-chart',
  'report-delete',
  'pencil',
  'connection-off',
  'report-download',
  'book',
  'connection-on',
  'download',
  'filter',
  'report-unknown',
  'ticket',
  'line-book',
  'split-arrows',
  'gavel',
  'users-outline',
  'user-outline',
  'admin-user',
  'trophy',
  'group',
  'whiteboard',
  'close-thin',
  'price-history',
  'drag-drop',
  'draggable-three',
  'draggable-two',
  'file-alt',
  'file-upload',
  'layout-icon',
  'new-window',
  'collapse-all',
  'expand-all',
  'plus-thin',
  'arrow-thin-up',
  'arrow-thin-right',
  'arrow-thin-left',
  'arrow-thin-down',
  'minus-thin',
];

const cmeAliasIcons = [
  'aggregate-fills',
  'blocks',
  'card-close',
  'card-max',
  'card-min',
  'chat-add',
  'chat-edit',
  'fills',
  'hold-all',
  'market-data',
  'mass-quote-cancel',
  'nightly-reports',
  'order-book',
  'kill-all',
  'orders',
  'rfqs',
  'trade-book',
  'options',
  'auctions',
  'associate-bid',
  'user-bid',
  'price-to-beat',
  'chat-room',
  'draggable-three',
  'draggable-two',
  'file-alt',
];

const faWebAppIcons = [
  'archive',
  'area-chart',
  'arrows',
  'arrows-h',
  'arrows-v',
  'assistive-listening-systems',
  'asterisk',
  'at',
  'balance-scale',
  'ban',
  'bank (alias)',
  'bar-chart',
  'bars',
  'bed',
  'beer',
  'bell',
  'bell-o',
  'bell-slash',
  'bell-slash-o',
  'binoculars',
  'bolt',
  'book',
  'bookmark',
  'bookmark-o',
  'briefcase',
  'building',
  'building-o',
  'bullhorn',
  'bullseye',
  'calculator',
  'calendar',
  'calendar-check-o',
  'calendar-minus-o',
  'calendar-o',
  'calendar-plus-o',
  'calendar-times-o',
  'camera',
  'camera-retro',
  'caret-square-o-down',
  'caret-square-o-left',
  'caret-square-o-right',
  'caret-square-o-up',
  'cart-arrow-down',
  'cart-plus',
  'certificate',
  'check',
  'check-circle',
  'check-circle-o',
  'check-square',
  'check-square-o',
  'circle',
  'circle-o',
  'circle-o-notch',
  'circle-thin',
  'clock-o',
  'clone',
  'close (alias)',
  'cloud',
  'cloud-download',
  'cloud-upload',
  'code',
  'code-fork',
  'coffee',
  'cog',
  'cogs',
  'comment',
  'comment-o',
  'commenting',
  'commenting-o',
  'comments',
  'comments-o',
  'copyright',
  'credit-card',
  'credit-card-alt',
  'crop',
  'cube',
  'cubes',
  'dashboard (alias)',
  'database',
  'desktop',
  'diamond',
  'dot-circle-o',
  'download',
  'edit (alias)',
  'ellipsis-h',
  'ellipsis-v',
  'envelope',
  'envelope-o',
  'envelope-square',
  'eraser',
  'exchange',
  'exclamation',
  'exclamation-circle',
  'exclamation-triangle',
  'external-link',
  'external-link-square',
  'eye',
  'eye-slash',
  'fax',
  'feed (alias)',
  'film',
  'filter',
  'flag',
  'flag-checkered',
  'flag-o',
  'flash (alias)',
  'folder',
  'folder-o',
  'folder-open',
  'folder-open-o',
  'frown-o',
  'futbol-o',
  'gavel',
  'gear (alias)',
  'gears (alias)',
  'globe',
  'graduation-cap',
  'group (alias)',
  'hand-grab-o (alias)',
  'hand-pointer-o',
  'hand-stop-o (alias)',
  'hashtag',
  'headphones',
  'heart',
  'heart-o',
  'heartbeat',
  'history',
  'home',
  'hourglass',
  'hourglass-1 (alias)',
  'hourglass-2 (alias)',
  'hourglass-3 (alias)',
  'hourglass-end',
  'hourglass-half',
  'hourglass-o',
  'hourglass-start',
  'i-cursor',
  'image (alias)',
  'inbox',
  'industry',
  'info',
  'info-circle',
  'institution (alias)',
  'key',
  'keyboard-o',
  'laptop',
  'legal (alias)',
  'level-down',
  'level-up',
  'lightbulb-o',
  'line-chart',
  'location-arrow',
  'lock',
  'magic',
  'mail-forward (alias)',
  'mail-reply (alias)',
  'mail-reply-all (alias)',
  'map',
  'map-marker',
  'map-o',
  'map-pin',
  'map-signs',
  'meh-o',
  'microphone',
  'microphone-slash',
  'minus',
  'minus-circle',
  'minus-square',
  'minus-square-o',
  'mobile',
  'mobile-phone (alias)',
  'money',
  'mortar-board (alias)',
  'mouse-pointer',
  'navicon (alias)',
  'newspaper-o',
  'object-group',
  'object-ungroup',
  'pencil',
  'pencil-square',
  'pencil-square-o',
  'percent',
  'phone',
  'phone-square',
  'photo (alias)',
  'picture-o',
  'pie-chart',
  'plug',
  'plus',
  'plus-circle',
  'plus-square',
  'plus-square-o',
  'power-off',
  'print',
  'puzzle-piece',
  'qrcode',
  'question',
  'question-circle',
  'question-circle-o',
  'quote-left',
  'quote-right',
  'random',
  'recycle',
  'refresh',
  'registered',
  'remove (alias)',
  'reorder (alias)',
  'reply',
  'reply-all',
  'retweet',
  'road',
  'rss',
  'rss-square',
  'search',
  'search-minus',
  'search-plus',
  'send (alias)',
  'send-o (alias)',
  'share',
  'share-alt',
  'share-alt-square',
  'share-square',
  'share-square-o',
  'shield',
  'shopping-bag',
  'shopping-basket',
  'shopping-cart',
  'sign-in',
  'sign-out',
  'signal',
  'sitemap',
  'sliders',
  'smile-o',
  'soccer-ball-o (alias)',
  'sort',
  'sort-alpha-asc',
  'sort-alpha-desc',
  'sort-amount-asc',
  'sort-amount-desc',
  'sort-asc',
  'sort-desc',
  'sort-down (alias)',
  'sort-numeric-asc',
  'sort-numeric-desc',
  'sort-up (alias)',
  'spinner',
  'square',
  'square-o',
  'star',
  'star-half',
  'star-half-empty (alias)',
  'star-half-full (alias)',
  'star-half-o',
  'star-o',
  'sticky-note',
  'sticky-note-o',
  'suitcase',
  'sun-o',
  'tablet',
  'tachometer',
  'tag',
  'tags',
  'tasks',
  'television',
  'terminal',
  'thumb-tack',
  'thumbs-down',
  'thumbs-o-down',
  'thumbs-o-up',
  'thumbs-up',
  'ticket',
  'times',
  'times-circle',
  'times-circle-o',
  'toggle-down (alias)',
  'toggle-left (alias)',
  'toggle-off',
  'toggle-on',
  'toggle-right (alias)',
  'toggle-up (alias)',
  'trademark',
  'trash',
  'trash-o',
  'trophy',
  'tty',
  'tv (alias)',
  'umbrella',
  'universal-access',
  'university',
  'unlock',
  'unlock-alt',
  'unsorted (alias)',
  'upload',
  'user',
  'user-plus',
  'user-times',
  'users',
  'video-camera',
  'volume-down',
  'volume-off',
  'volume-up',
  'warning (alias)',
  'wifi',
  'wrench'
];

const faFileTypeIcons = [
  'file',
  'file-archive-o',
  'file-audio-o',
  'file-code-o',
  'file-excel-o',
  'file-image-o',
  'file-movie-o (alias)',
  'file-o',
  'file-pdf-o',
  'file-photo-o (alias)',
  'file-picture-o (alias)',
  'file-powerpoint-o',
  'file-sound-o (alias)',
  'file-text',
  'file-text-o',
  'file-video-o',
  'file-word-o',
  'file-zip-o (alias)'
];

const faCurrencyIcons = [
  'bitcoin (alias)',
  'btc',
  'cny (alias)',
  'dollar (alias)',
  'eur',
  'euro (alias)',
  'gbp',
  'gg',
  'gg-circle',
  'ils',
  'inr',
  'jpy',
  'krw',
  'money',
  'rmb (alias)',
  'rouble (alias)',
  'rub',
  'ruble (alias)',
  'rupee (alias)',
  'shekel (alias)',
  'sheqel (alias)',
  'try',
  'turkish-lira (alias)',
  'usd',
  'won (alias)',
  'yen (alias)'
];

const faTextEditorIcons = [
  'align-center',
  'align-justify',
  'align-left',
  'align-right',
  'bold',
  'chain (alias)',
  'chain-broken',
  'clipboard',
  'columns',
  'copy (alias)',
  'cut (alias)',
  'dedent (alias)',
  'eraser',
  'file',
  'file-o',
  'file-text',
  'file-text-o',
  'files-o',
  'floppy-o',
  'font',
  'header',
  'indent',
  'italic',
  'link',
  'list',
  'list-alt',
  'list-ol',
  'list-ul',
  'outdent',
  'paperclip',
  'paragraph',
  'paste (alias)',
  'repeat',
  'rotate-left (alias)',
  'rotate-right (alias)',
  'save (alias)',
  'scissors',
  'strikethrough',
  'subscript',
  'superscript',
  'table',
  'text-height',
  'text-width',
  'th',
  'th-large',
  'th-list',
  'underline',
  'undo',
  'unlink (alias)'
];

const faDirectionalIcons = [
  'angle-double-down',
  'angle-double-left',
  'angle-double-right',
  'angle-double-up',
  'angle-down',
  'angle-left',
  'angle-right',
  'angle-up',
  'arrow-circle-down',
  'arrow-circle-left',
  'arrow-circle-o-down',
  'arrow-circle-o-left',
  'arrow-circle-o-right',
  'arrow-circle-o-up',
  'arrow-circle-right',
  'arrow-circle-up',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'arrows',
  'arrows-alt',
  'arrows-h',
  'arrows-v',
  'caret-down',
  'caret-left',
  'caret-right',
  'caret-square-o-down',
  'caret-square-o-left',
  'caret-square-o-right',
  'caret-square-o-up',
  'caret-up',
  'chevron-circle-down',
  'chevron-circle-left',
  'chevron-circle-right',
  'chevron-circle-up',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'exchange',
  'hand-o-down',
  'hand-o-left',
  'hand-o-right',
  'hand-o-up',
  'long-arrow-down',
  'long-arrow-left',
  'long-arrow-right',
  'long-arrow-up',
  'toggle-down (alias)',
  'toggle-left (alias)',
  'toggle-right (alias)',
  'toggle-up (alias)'
];

const faVideoPlayerIcons = [
  'arrows-alt',
  'backward',
  'compress',
  'eject',
  'expand',
  'fast-backward',
  'fast-forward',
  'forward',
  'pause',
  'pause-circle',
  'pause-circle-o',
  'play',
  'play-circle',
  'play-circle-o',
  'random',
  'step-backward',
  'step-forward',
  'stop',
  'stop-circle',
  'stop-circle-o',
  'youtube-play'
];

const faBrandIcons = [
  'facebook',
  'google',
  'instagram',
  'linkedin',
  'pinterest',
  'slideshare',
  'twitter',
  'wechat (alias)',
  'weibo',
  'youtube'
];

class Icons extends Component {

  constructor(props) {
    super(props)
  }

  renderIcons(icons, iconClassPrefix) {
    return (
      <div className="grid grid--bleed icon-documentation">
        {icons.map((icon, index) => {

          let isAlias   = icon.indexOf('alias') > -1;
          let iconClass = icon.replace(' (alias)', '');
          let iconText  = [iconClass, (isAlias ? <small key={[icon, index, 'small']} className="text-muted">&nbsp;(alias)</small> : '')];

          iconClass = iconClassPrefix + iconClass;

          return (
            <div key={[icon, index, 'div']} className="grid__col-xs-4 grid__col-md-4 grid__col-lg-3 grid--direction-row grid--align-center">
              <i className={iconClass}></i>&nbsp;{iconText}
            </div>
          )

        })}
      </div>
    )
  }

  render() {

    return(
    <section>

      <a className="anchor" id="icons"></a>
      <h2>Icons</h2>
      <h3>Branded</h3>
      <p>Use an <code className="inline">&lt;i&gt;</code> for icon elements. You just simply apply the appropriate classes that match the icon you want to use. Here's what the markup looks like:</p>
      <pre><code className="language-html">&lt;i class=&quot;icon-cme-[name]&quot;&gt;&lt;/i&gt;</code></pre>
      <br/>

      {this.renderIcons(cmeBrandedIcons, "icon-cme-")}

      <br/><hr/>

      <h3>Branded Icon Aliases</h3>

      <div className="callout">
        <strong>Note:</strong> Some of the generic branded icons above are also available as specific aliases for use within applications such as CME One.
      </div>

      <br/>
      <p>The following icons are additionally available as aliases and are used in the same way:</p>

      <pre><code className="language-html">&lt;i class=&quot;icon-cme-[alias]&quot;&gt;&lt;/i&gt;</code></pre>
      <br/>

      {this.renderIcons(cmeAliasIcons, "icon-cme-")}

      <br/><br/>
      <h3>Unbranded</h3>
      <p>Use an <code className="inline">&lt;i&gt;</code> for icon elements. You just simply apply the appropriate classes that match the icon you want to use. Here's what the markup looks like:</p>
      <pre><code className="language-html">&lt;i class=&quot;fab fa-[icon]&quot;&gt;&lt;/i&gt;</code></pre>
      <pre><code className="language-html">&lt;i class=&quot;fas fa-[icon]&quot;&gt;&lt;/i&gt;</code></pre>
      <br/>
      <p>We use the icon library <a href="https://fontawesome.com/icons?d=gallery&m=free" target="_blank">font awesome</a>. <b>This is a subset of those available, please visit their documentation for more.</b> As you can see from the markup there are 2 syntaxes, so make sure you check the syntax provided by font awesome for the icon you use. To include it in your project insert the following</p>
      <pre><code className="language-html">{`<!-- Insert this in the <head> element on your page -->
<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> `}</code></pre>

    </section>
  )
}
}

export default Icons



// WEBPACK FOOTER //
// ./styleguide/components/sections/Icons.js